(() => {
  const raiz = document.getElementById('carrito-premium');
  if (!raiz || raiz.dataset.iniciado === 'true') return;
  raiz.dataset.iniciado = 'true';

  const pasoFormulario = raiz.querySelector('[data-paso="formulario"]');
  const pasoResumen = raiz.querySelector('[data-paso="resumen"]');
  const formulario = raiz.querySelector('[data-formulario-carrito]');
  const barraProgreso = raiz.querySelector('[data-barra-progreso]');
  const textoProgreso = raiz.querySelector('[data-texto-progreso]');
  const eyebrow = raiz.querySelector('[data-eyebrow-carrito]');
  const tituloCarrito = raiz.querySelector('[data-titulo-carrito]');
  const resumenNombre = raiz.querySelector('[data-producto-nombre]');
  const resumenPrecio = raiz.querySelector('[data-producto-precio]');
  const mensajeFormulario = raiz.querySelector('[data-mensaje-formulario]');
  const botonContinuar = raiz.querySelector('[data-boton-continuar]');
  const textoBoton = raiz.querySelector('[data-texto-boton]');
  const contenedorLineas = raiz.querySelector('[data-lineas-carrito]');
  const subtotalCarrito = raiz.querySelector('[data-subtotal-carrito]');
  const subtotalOriginal = raiz.querySelector('[data-subtotal-original]');
  const subtotalAhorro = raiz.querySelector('[data-subtotal-ahorro]');
  const botonSeguirViendo = raiz.querySelector('[data-seguir-viendo]');

  const inputVariantId = raiz.querySelector('[data-variant-id]');
  const inputTipoProducto = raiz.querySelector('[data-tipo-producto]');
  const inputTituloProducto = raiz.querySelector('[data-titulo-producto]');

  const grupoPersona1 = raiz.querySelector('[data-grupo="persona_1"]');
  const grupoPersona2 = raiz.querySelector('[data-grupo="persona_2"]');
  const grupoRevolucion = raiz.querySelector('[data-grupo="revolucion"]');

  const inputNombrePersona = raiz.querySelector('#nombre_persona');
  const inputFechaNacimiento = raiz.querySelector('#fecha_nacimiento');
  const inputHoraNacimiento = raiz.querySelector('#hora_nacimiento');
  const inputLugarNacimiento = raiz.querySelector('#lugar_nacimiento');

  const inputNombrePersonaPareja = raiz.querySelector('#nombre_persona_pareja');
  const inputFechaNacimientoPareja = raiz.querySelector('#fecha_nacimiento_pareja');
  const inputHoraNacimientoPareja = raiz.querySelector('#hora_nacimiento_pareja');
  const inputLugarNacimientoPareja = raiz.querySelector('#lugar_nacimiento_pareja');

 const inputAnioRevolucion = raiz.querySelector('#anio_revolucion');
const inputLugarRevolucion = raiz.querySelector('#lugar_revolucion');

  let productoActual = null;
  let modoEdicion = false;
  let identificadorEditando = null;
  let numeroPersonaEditando = null;

  const rutas = {
    agregar: `${window.Shopify?.routes?.root || "/"}cart/add.js`,
    carrito: `${window.Shopify?.routes?.root || "/"}cart.js`,
    cambiar: `${window.Shopify?.routes?.root || "/"}cart/change.js`
  };

    function obtenerValorNumericoDesdePrecio(textoPrecio) {
    if (!textoPrecio) return 0;

    const limpio = String(textoPrecio)
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const numero = Number(limpio);

    return Number.isFinite(numero) ? numero : 0;
  }

  function trackCarritoPremium(evento, data = {}) {
    const currency = window.Shopify?.currency?.active || 'ARS';

    const payload = {
      event_source: 'carrito_premium',
      product_name: productoActual?.nombre || data.product_name || '',
      variant_id: String(productoActual?.variantId || data.variant_id || ''),
      product_type: productoActual?.tipoProducto || data.product_type || '',
      quantity: Number(productoActual?.quantity || data.quantity || 1),
      value: Number(data.value || obtenerValorNumericoDesdePrecio(productoActual?.precio) || 0),
      currency
    };

    // META PIXEL
    if (typeof fbq === 'function') {
      if (evento === 'open_form') {
        fbq('trackCustom', 'OpenCartForm', payload);
      }
    }


    // SHOPIFY CUSTOMER EVENTS - evento custom
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(`mis_astros:${evento}`, payload);
      }
    } catch (error) {
      console.warn('[TRACK MIS ASTROS] Shopify analytics error', error);
    }

    // Para testear en consola
    console.log(`[TRACK MIS ASTROS] ${evento}`, payload);
  }
  function generarIdInterno() {
    return `cp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

let scrollCarritoPremium = 0;

function bloquearPaginaDetrasCarrito() {
  scrollCarritoPremium = window.scrollY || document.documentElement.scrollTop || 0;

  document.documentElement.classList.add('carrito-premium-html-abierto');
  document.body.classList.add('carrito-premium-abierto');

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollCarritoPremium}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function desbloquearPaginaDetrasCarrito() {
  document.documentElement.classList.remove('carrito-premium-html-abierto');
  document.body.classList.remove('carrito-premium-abierto');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  window.scrollTo(0, scrollCarritoPremium);
}


function abrirCarrito() {
  bloquearPaginaDetrasCarrito();

  raiz.classList.add('is-abierto');
  raiz.setAttribute('aria-hidden', 'false');
}

function cerrarCarrito() {
  raiz.classList.remove('is-abierto');
  raiz.setAttribute('aria-hidden', 'true');

  desbloquearPaginaDetrasCarrito();
}

  function irAPaso(nombrePaso) {
    const esFormulario = nombrePaso === 'formulario';

    pasoFormulario.classList.toggle('is-activo', esFormulario);
    pasoResumen.classList.toggle('is-activo', !esFormulario);

    if (esFormulario) {
      barraProgreso.style.width = '50%';
      textoProgreso.textContent = 'Paso 1 de 2';
      eyebrow.textContent = modoEdicion ? 'Editar producto' : 'Tu experiencia';
      tituloCarrito.textContent = modoEdicion ? 'Editá tus datos' : 'Completá tus datos';
      textoBoton.textContent = modoEdicion ? 'Guardar cambios' : 'Continuar';
    } else {
      barraProgreso.style.width = '100%';
      textoProgreso.textContent = 'Paso 2 de 2';
      eyebrow.textContent = 'Tu compra';
      tituloCarrito.textContent = 'Resumen';
      textoBoton.textContent = 'Continuar';
    }
  }

  function limpiarMensaje() {
    if (mensajeFormulario) mensajeFormulario.textContent = '';
  }

  function mostrarMensaje(texto) {
    if (mensajeFormulario) mensajeFormulario.textContent = texto;
  }

  function setCargando(estado) {
    if (!botonContinuar || !textoBoton) return;
    botonContinuar.disabled = estado;
    botonContinuar.classList.toggle('is-cargando', estado);
    textoBoton.textContent = estado
      ? 'Guardando...'
      : (modoEdicion ? 'Guardar cambios' : 'Continuar');
  }

  function resetearFormulario() {
    if (!formulario) return;
    formulario.reset();
    limpiarMensaje();
  }

  function configurarCamposSegunProducto(tipoProducto) {
    if (grupoPersona1) grupoPersona1.hidden = false;
    if (grupoPersona2) grupoPersona2.hidden = true;
    if (grupoRevolucion) grupoRevolucion.hidden = true;

    if (tipoProducto === 'sinastria' && grupoPersona2) {
      grupoPersona2.hidden = false;
    }

    if (tipoProducto === 'revolucion_solar' && grupoRevolucion) {
      grupoRevolucion.hidden = false;
    }
  }

  function detectarTipoProducto(item) {
    const propiedades = item.properties || {};

    if (propiedades["Tipo de producto interno"]) {
      return propiedades["Tipo de producto interno"];
    }

    const claves = Object.keys(propiedades);

    if (
      claves.includes('Fecha de nacimiento pareja') ||
      claves.includes('Nombre pareja') ||
      claves.includes('Lugar de nacimiento pareja')
    ) {
      return 'sinastria';
    }

    if (claves.includes('Lugar de revolución solar')) {
      return 'revolucion_solar';
    }

    return 'carta_natal';
  }

  function validarFormulario(tipoProducto) {
    if (!inputNombrePersona?.value.trim()) return 'Completá el nombre.';
    if (!inputFechaNacimiento?.value) return 'Completá la fecha de nacimiento.';
    if (!inputHoraNacimiento?.value) return 'Completá la hora de nacimiento.';
    if (!inputLugarNacimiento?.value.trim()) return 'Completá el lugar de nacimiento.';

    if (tipoProducto === 'sinastria') {
      if (!inputNombrePersonaPareja?.value.trim()) return 'Completá el nombre de la otra persona.';
      if (!inputFechaNacimientoPareja?.value) return 'Completá la fecha de nacimiento de la otra persona.';
      if (!inputHoraNacimientoPareja?.value) return 'Completá la hora de nacimiento de la otra persona.';
      if (!inputLugarNacimientoPareja?.value.trim()) return 'Completá el lugar de nacimiento de la otra persona.';
    }

  if (tipoProducto === 'revolucion_solar') {
  if (!inputAnioRevolucion?.value.trim()) {
    return 'Completá el año de la revolución.';
  }

  if (!inputLugarRevolucion?.value.trim()) {
    return 'Completá el lugar donde pasó o va a pasar su cumpleaños.';
  }
}

    return '';
  }

  function obtenerProperties(tipoProducto, opciones = {}) {
    const {
      identificadorInterno = generarIdInterno(),
      numeroPersona = '',
      estadoDatos = 'Completo'
    } = opciones;

    const properties = {
      "Tipo de producto interno": tipoProducto,
      "Identificador interno": identificadorInterno,
      "Estado de datos": estadoDatos
    };

    if (numeroPersona) properties["Número de persona"] = String(numeroPersona);

    properties["Nombre"] = inputNombrePersona?.value.trim() || '';
    properties["Fecha de nacimiento"] = inputFechaNacimiento?.value || '';
    properties["Hora de nacimiento"] = inputHoraNacimiento?.value || '';
    properties["Lugar de nacimiento"] = inputLugarNacimiento?.value.trim() || '';

    if (tipoProducto === 'sinastria') {
      properties["Nombre pareja"] = inputNombrePersonaPareja?.value.trim() || '';
      properties["Fecha de nacimiento pareja"] = inputFechaNacimientoPareja?.value || '';
      properties["Hora de nacimiento pareja"] = inputHoraNacimientoPareja?.value || '';
      properties["Lugar de nacimiento pareja"] = inputLugarNacimientoPareja?.value.trim() || '';
    }

if (tipoProducto === 'revolucion_solar') {
  properties["Año de la revolución solar"] = inputAnioRevolucion?.value.trim() || '';
  properties["Lugar de revolución solar"] = inputLugarRevolucion?.value.trim() || '';
}

    return properties;
  }

  function obtenerPropertiesPendientes(tipoProducto, indicePersona) {
    return {
      "Tipo de producto interno": tipoProducto,
      "Identificador interno": generarIdInterno(),
      "Estado de datos": "Pendiente",
      "Número de persona": String(indicePersona)
    };
  }

  function formatearDinero(cents, locale = 'es-AR', currency = window.Shopify?.currency?.active || 'USD') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format((cents || 0) / 100);
  }

  function numeroPersonaDeItem(item) {
    const numero = parseInt(item?.properties?.["Número de persona"] || '9999', 10);
    return Number.isFinite(numero) ? numero : 9999;
  }

  function obtenerTituloVisual(item) {
    const properties = item.properties || {};
    const nombre = properties["Nombre"]?.trim();
    const estado = properties["Estado de datos"];
    const numeroPersona = properties["Número de persona"]?.trim();

    if (nombre) {
      if (numeroPersona) return `${item.product_title} — Persona ${numeroPersona}: ${nombre}`;
      return `${item.product_title} — ${nombre}`;
    }

    if (estado === 'Pendiente') {
      if (numeroPersona) return `${item.product_title} — Persona ${numeroPersona}: Pendiente de completar`;
      return `${item.product_title} — Pendiente de completar`;
    }

    return item.product_title;
  }

  function itemConMeta(item, index) {
    return {
      ...item,
      __lineaReal: index + 1,
      __identificadorInterno: item?.properties?.["Identificador interno"] || `sin_id_${index + 1}`,
      __numeroPersona: numeroPersonaDeItem(item)
    };
  }

  function ordenarItemsParaVista(items) {
    return items
      .map(itemConMeta)
      .sort((a, b) => {
        if (a.__numeroPersona !== b.__numeroPersona) return a.__numeroPersona - b.__numeroPersona;
        return a.__lineaReal - b.__lineaReal;
      });
  }

  function renderLineas(carrito) {
    if (!contenedorLineas || !subtotalCarrito) return;

    if (!carrito.items || !carrito.items.length) {
      contenedorLineas.innerHTML = `
        <div class="carrito-premium__linea">
          <div class="carrito-premium__linea-titulo">Tu carrito está vacío.</div>
          <div class="carrito-premium__linea-meta" style="margin-top:8px;">
            Podés seguir explorando y sumar una experiencia cuando quieras.
          </div>
        </div>
      `;
      subtotalCarrito.textContent = formatearDinero(0);
      if (subtotalOriginal) subtotalOriginal.textContent = '';
      if (subtotalAhorro) subtotalAhorro.textContent = '';
      return;
    }

    const itemsOrdenados = ordenarItemsParaVista(carrito.items);

    contenedorLineas.innerHTML = itemsOrdenados.map((item) => {
      const propiedades = item.properties || {};
      const propiedadesVisibles = Object.entries(propiedades)
        .filter(([clave, valor]) =>
          clave &&
          valor &&
          clave !== 'Tipo de producto interno' &&
          clave !== 'Identificador interno'
        )
        .map(([clave, valor]) => `<div>${clave}: ${valor}</div>`)
        .join('');

      const precioActual = typeof item.final_line_price === 'number'
        ? item.final_line_price
        : item.line_price;

      const precioOriginal = typeof item.original_line_price === 'number'
        ? item.original_line_price
        : precioActual;

      const ahorroLinea = Math.max(0, precioOriginal - precioActual);

const tipoProductoInterno = propiedades["Tipo de producto interno"] || '';

const esProductoSinDatos =
  tipoProductoInterno === 'taza';

const muestraVarianteElegida =
  tipoProductoInterno === 'revolucion_solar' ||
  tipoProductoInterno === 'taza';

const nombreVariante =
  item.variant_title && item.variant_title !== 'Default Title'
    ? item.variant_title
    : '';

const varianteProductoHTML =
  muestraVarianteElegida && nombreVariante
    ? `<div class="carrito-premium__linea-variante">${nombreVariante}</div>`
    : '';

return `
        <div class="carrito-premium__linea">
          <div class="carrito-premium__linea-top">
            <div>
              <div class="carrito-premium__linea-titulo">${obtenerTituloVisual(item)}</div>
${varianteProductoHTML}
            </div>
            <div class="carrito-premium__linea-acciones">
             ${!esProductoSinDatos ? `
  <button
    type="button"
    class="carrito-premium__editar"
    data-editar-identificador="${item.__identificadorInterno}"
  >
    Editar
  </button>
` : ''}
              <button
                type="button"
                class="carrito-premium__quitar"
                data-quitar-identificador="${item.__identificadorInterno}"
              >
                Quitar
              </button>
            </div>
          </div>

          <div class="carrito-premium__linea-meta">
            Cantidad: ${item.quantity}
            ${propiedadesVisibles ? `<div style="margin-top:8px">${propiedadesVisibles}</div>` : ''}
          </div>

          <div class="carrito-premium__linea-precios">
            ${precioOriginal > precioActual ? `<div class="carrito-premium__linea-precio-anterior">${formatearDinero(precioOriginal)}</div>` : ''}
            <div class="carrito-premium__linea-precio">${formatearDinero(precioActual)}</div>
            ${ahorroLinea > 0 ? `<div class="carrito-premium__linea-ahorro">Ahorrás ${formatearDinero(ahorroLinea)}</div>` : ''}
          </div>
        </div>
      `;
    }).join('');

    const totalActual = typeof carrito.total_price === 'number' ? carrito.total_price : 0;
    const totalOriginal = typeof carrito.original_total_price === 'number'
      ? carrito.original_total_price
      : totalActual;
    const ahorroTotal = Math.max(0, totalOriginal - totalActual);

    subtotalCarrito.textContent = formatearDinero(totalActual);
    if (subtotalOriginal) subtotalOriginal.textContent = totalOriginal > totalActual ? formatearDinero(totalOriginal) : '';
    if (subtotalAhorro) subtotalAhorro.textContent = ahorroTotal > 0 ? `Ahorrás ${formatearDinero(ahorroTotal)}` : '';
  }

  async function obtenerCarrito() {
    const response = await fetch(rutas.carrito, {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) throw new Error('No se pudo obtener el carrito.');
    return response.json();
  }

  async function agregarItemsAlCarrito(items) {
    const response = await fetch(rutas.agregar, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let mensaje = 'No se pudo agregar el producto al carrito.';
      try {
        const errorData = await response.json();
        if (errorData?.description) mensaje = errorData.description;
      } catch (_) {}
      throw new Error(mensaje);
    }

    return response.json();
  }

  async function quitarLineaDelCarrito(line) {
    const response = await fetch(rutas.cambiar, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity: 0 })
    });

    if (!response.ok) throw new Error('No se pudo quitar el producto.');
    return response.json();
  }

  function construirItemsParaNuevoProducto() {
    const cantidad = Math.max(1, Number(productoActual?.quantity || 1));
    const variantId = Number(productoActual?.variantId);
    const tipoProducto = productoActual?.tipoProducto || 'carta_natal';

    const items = [
      {
        id: variantId,
        quantity: 1,
        properties: obtenerProperties(tipoProducto, {
          identificadorInterno: generarIdInterno(),
          numeroPersona: 1,
          estadoDatos: 'Completo'
        })
      }
    ];

    if (cantidad > 1) {
      for (let i = 2; i <= cantidad; i += 1) {
        items.push({
          id: variantId,
          quantity: 1,
          properties: obtenerPropertiesPendientes(tipoProducto, i)
        });
      }
    }

    return items;
  }

  function prepararProducto(data) {
    modoEdicion = false;
    identificadorEditando = null;
    numeroPersonaEditando = null;

    productoActual = {
      variantId: data.variantId,
      nombre: data.nombre || 'Producto',
      precio: data.precioTexto || '—',
      tipoProducto: data.tipoProducto || 'carta_natal',
      quantity: Math.max(1, Number(data.quantity || 1))
    };

    if (inputVariantId) inputVariantId.value = productoActual.variantId || '';
    if (inputTipoProducto) inputTipoProducto.value = productoActual.tipoProducto;
    if (inputTituloProducto) inputTituloProducto.value = productoActual.nombre;

    if (resumenNombre) resumenNombre.textContent = productoActual.nombre;
    if (resumenPrecio) resumenPrecio.textContent = productoActual.precio;

    configurarCamposSegunProducto(productoActual.tipoProducto);
    resetearFormulario();
    irAPaso('formulario');
    abrirCarrito();
  }

  function cargarFormularioDesdeItem(item) {
    modoEdicion = true;

    const tipoProducto = detectarTipoProducto(item);
    const properties = item.properties || {};

    identificadorEditando = properties["Identificador interno"] || generarIdInterno();
    numeroPersonaEditando = properties["Número de persona"] || '';

    productoActual = {
      variantId: item.variant_id,
      nombre: item.product_title || 'Producto',
      precio: formatearDinero(item.final_line_price || item.line_price || 0),
      tipoProducto,
      quantity: 1
    };

    if (inputVariantId) inputVariantId.value = productoActual.variantId || '';
    if (inputTipoProducto) inputTipoProducto.value = productoActual.tipoProducto;
    if (inputTituloProducto) inputTituloProducto.value = productoActual.nombre;

    if (resumenNombre) resumenNombre.textContent = productoActual.nombre;
    if (resumenPrecio) resumenPrecio.textContent = productoActual.precio;

    configurarCamposSegunProducto(tipoProducto);
    resetearFormulario();

    if (inputNombrePersona) inputNombrePersona.value = properties["Nombre"] || '';
    if (inputFechaNacimiento) inputFechaNacimiento.value = properties["Fecha de nacimiento"] || '';
    if (inputHoraNacimiento) inputHoraNacimiento.value = properties["Hora de nacimiento"] || '';
    if (inputLugarNacimiento) inputLugarNacimiento.value = properties["Lugar de nacimiento"] || '';

    if (inputNombrePersonaPareja) inputNombrePersonaPareja.value = properties["Nombre pareja"] || '';
    if (inputFechaNacimientoPareja) inputFechaNacimientoPareja.value = properties["Fecha de nacimiento pareja"] || '';
    if (inputHoraNacimientoPareja) inputHoraNacimientoPareja.value = properties["Hora de nacimiento pareja"] || '';
    if (inputLugarNacimientoPareja) inputLugarNacimientoPareja.value = properties["Lugar de nacimiento pareja"] || '';

   if (inputAnioRevolucion) inputAnioRevolucion.value = properties["Año de la revolución solar"] || '';
if (inputLugarRevolucion) inputLugarRevolucion.value = properties["Lugar de revolución solar"] || '';

    irAPaso('formulario');
    abrirCarrito();
  }

  function obtenerDataDesdeBoton(boton) {
    return {
      variantId: boton.dataset.variantId,
      nombre: boton.dataset.productoNombre,
      precioTexto: boton.dataset.productoPrecio,
      tipoProducto: boton.dataset.tipoProducto,
      quantity: boton.dataset.cantidad || 1
    };
  }

  function encontrarItemPorIdentificador(carrito, identificador) {
    if (!carrito?.items?.length || !identificador) return null;

    for (let i = 0; i < carrito.items.length; i += 1) {
      const item = carrito.items[i];
      const idInterno = item?.properties?.["Identificador interno"];
      if (idInterno === identificador) {
        return { item, line: i + 1 };
      }
    }

    return null;
  }


function normalizarResultadoCiudad(resultado) {
  if (!resultado) return '';

  if (typeof resultado === 'string') return resultado;

  return (
    resultado.formatted ||
    resultado.label ||
    resultado.name ||
    resultado.display_name ||
    resultado.description ||
    [resultado.city, resultado.state, resultado.country].filter(Boolean).join(', ') ||
    ''
  );
}

function extraerResultadosCiudades(data) {
  if (Array.isArray(data)) return data;

  return (
    data?.results ||
    data?.items ||
    data?.suggestions ||
    data?.predictions ||
    data?.data ||
    []
  );
}

function inicializarSelectorCiudades(input) {
  if (!input || input.dataset.selectorCiudadesIniciado === 'true') return;

  input.dataset.selectorCiudadesIniciado = 'true';
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('spellcheck', 'false');

  const campo = input.closest('.campo');
  if (!campo) return;

  campo.classList.add('campo--ciudad');

  let contenedor = campo.querySelector('[data-sugerencias-ciudad]');

  if (!contenedor) {
    contenedor = document.createElement('div');
    contenedor.className = 'carrito-premium__sugerencias-ciudad';
    contenedor.setAttribute('data-sugerencias-ciudad', '');
    contenedor.hidden = true;
    input.insertAdjacentElement('afterend', contenedor);
  }

  let timeoutBusqueda = null;
  let controller = null;
  let opciones = [];
  let indiceActivo = -1;

  function ocultarSugerencias() {
    contenedor.hidden = true;
    contenedor.innerHTML = '';
    opciones = [];
    indiceActivo = -1;
  }

  function pintarSugerencias(resultados) {
    opciones = resultados
      .map(normalizarResultadoCiudad)
      .filter(Boolean)
      .slice(0, 6);

    indiceActivo = -1;

    if (!opciones.length) {
      ocultarSugerencias();
      return;
    }

    contenedor.innerHTML = opciones.map((texto, index) => `
      <button
        type="button"
        class="carrito-premium__sugerencia-ciudad"
        data-ciudad-index="${index}"
      >
        ${texto}
      </button>
    `).join('');

    contenedor.hidden = false;
  }

  async function buscarCiudades(consulta) {
    const texto = consulta.trim();

    if (texto.length < 3) {
      ocultarSugerencias();
      return;
    }

    if (controller) controller.abort();

    controller = new AbortController();

    try {
     const url = `https://mis-astros-geo-api.vercel.app/api/places?q=${encodeURIComponent(texto)}`;

      const response = await fetch(url, {
        headers: { 'Accept': 'application/json' },
        signal: controller.signal
      });

      if (!response.ok) {
        ocultarSugerencias();
        return;
      }

      const data = await response.json();
      const resultados = extraerResultadosCiudades(data);

      pintarSugerencias(resultados);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[Carrito Premium] Error buscando ciudades:', error);
      }
    }
  }

  input.addEventListener('input', () => {
    clearTimeout(timeoutBusqueda);

    timeoutBusqueda = setTimeout(() => {
      buscarCiudades(input.value);
    }, 280);
  });

  input.addEventListener('keydown', (event) => {
    if (contenedor.hidden || !opciones.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      indiceActivo = Math.min(indiceActivo + 1, opciones.length - 1);
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      indiceActivo = Math.max(indiceActivo - 1, 0);
    }

    if (event.key === 'Enter' && indiceActivo >= 0) {
      event.preventDefault();
      input.value = opciones[indiceActivo];
      ocultarSugerencias();
    }

    if (event.key === 'Escape') {
      ocultarSugerencias();
    }

    contenedor.querySelectorAll('[data-ciudad-index]').forEach((boton, index) => {
      boton.classList.toggle('is-activo', index === indiceActivo);
    });
  });

  contenedor.addEventListener('mousedown', (event) => {
    const boton = event.target.closest('[data-ciudad-index]');
    if (!boton) return;

    event.preventDefault();

    const index = Number(boton.dataset.ciudadIndex);
    const ciudad = opciones[index];

    if (ciudad) {
      input.value = ciudad;
      ocultarSugerencias();
    }
  });

  input.addEventListener('blur', () => {
    setTimeout(ocultarSugerencias, 160);
  });
}

[
  inputLugarNacimiento,
  inputLugarNacimientoPareja,
  inputLugarRevolucion
].forEach(inicializarSelectorCiudades);


  document.addEventListener('click', async (event) => {
 const botonAbrir = event.target.closest('[data-abrir-carrito-premium]');
if (botonAbrir) {
  event.preventDefault();

  if (botonAbrir.hasAttribute('data-ver-resumen-carrito')) {
    try {
      const carrito = await obtenerCarrito();
      renderLineas(carrito);
      modoEdicion = false;
      identificadorEditando = null;
      numeroPersonaEditando = null;
      irAPaso('resumen');
      abrirCarrito();
    } catch (_) {
      abrirCarrito();
      irAPaso('resumen');
    }

    return;
  }

const dataProducto = obtenerDataDesdeBoton(botonAbrir);

if (dataProducto.tipoProducto === 'taza') {
  try {
    const cantidad = Math.max(1, Number(dataProducto.quantity || 1));

    await agregarItemsAlCarrito([
      {
        id: Number(dataProducto.variantId),
        quantity: cantidad,
        properties: {
          "Tipo de producto interno": "taza",
          "Identificador interno": generarIdInterno()
        }
      }
    ]);

    const carrito = await obtenerCarrito();
    renderLineas(carrito);

    productoActual = {
      variantId: dataProducto.variantId,
      nombre: dataProducto.nombre || 'Producto',
      precio: dataProducto.precioTexto || '—',
      tipoProducto: dataProducto.tipoProducto || 'taza',
      quantity: Math.max(1, Number(dataProducto.quantity || 1))
    };

    trackCarritoPremium('add_to_cart', {
      value: carrito.total_price ? carrito.total_price / 100 : undefined
    });
    modoEdicion = false;
    identificadorEditando = null;
    numeroPersonaEditando = null;

    irAPaso('resumen');
    abrirCarrito();
  } catch (error) {
    console.error('Error al agregar taza al carrito:', error);
  }

  return;
}

prepararProducto(dataProducto);
trackCarritoPremium('open_form');
return;
}

    const finalizarCompra = event.target.closest('[data-finalizar-compra-carrito]');
    if (finalizarCompra) {
      try {
        const carrito = await obtenerCarrito();

        trackCarritoPremium('initiate_checkout', {
          value: carrito.total_price ? carrito.total_price / 100 : undefined,
          quantity: carrito.item_count || 1
        });
      } catch (_) {}
    }

    const cerrar = event.target.closest('[data-cerrar-carrito]');
    if (cerrar) {
      event.preventDefault();
      cerrarCarrito();
      return;
    }

    const quitar = event.target.closest('[data-quitar-identificador]');
    if (quitar) {
      event.preventDefault();

      const identificador = quitar.dataset.quitarIdentificador;
      if (!identificador) return;

      const textoOriginal = quitar.textContent;
      quitar.disabled = true;
      quitar.textContent = 'Quitando...';

      try {
        const carrito = await obtenerCarrito();
        const encontrado = encontrarItemPorIdentificador(carrito, identificador);
        if (!encontrado) {
          renderLineas(carrito);
          return;
        }

        const carritoActualizado = await quitarLineaDelCarrito(encontrado.line);
        renderLineas(carritoActualizado);
      } catch (_) {
        quitar.disabled = false;
        quitar.textContent = textoOriginal;
      }

      return;
    }

    const editar = event.target.closest('[data-editar-identificador]');
    if (editar) {
      event.preventDefault();

      const identificador = editar.dataset.editarIdentificador;
      if (!identificador) return;

      try {
        const carrito = await obtenerCarrito();
        const encontrado = encontrarItemPorIdentificador(carrito, identificador);
        if (!encontrado?.item) return;
        cargarFormularioDesdeItem(encontrado.item);
      } catch (_) {}

      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && raiz.classList.contains('is-abierto')) {
      cerrarCarrito();
    }
  });

  if (botonSeguirViendo) {
    botonSeguirViendo.addEventListener('click', () => {
      cerrarCarrito();
    });
  }

  if (formulario) {
    formulario.addEventListener('submit', async (event) => {
      event.preventDefault();
      limpiarMensaje();

      if (!productoActual?.variantId) {
        mostrarMensaje('No encontramos la variante del producto.');
        return;
      }

      const errorValidacion = validarFormulario(productoActual.tipoProducto);
      if (errorValidacion) {
        mostrarMensaje(errorValidacion);
        return;
      }

      try {
        setCargando(true);

        if (modoEdicion && identificadorEditando) {
          const carritoActual = await obtenerCarrito();
          const encontrado = encontrarItemPorIdentificador(carritoActual, identificadorEditando);

          if (!encontrado) {
            throw new Error('No encontramos el producto que estabas editando.');
          }

          await quitarLineaDelCarrito(encontrado.line);

          await agregarItemsAlCarrito([
            {
              id: Number(productoActual.variantId),
              quantity: 1,
              properties: obtenerProperties(productoActual.tipoProducto, {
                identificadorInterno: identificadorEditando,
                numeroPersona: numeroPersonaEditando || '',
                estadoDatos: 'Completo'
              })
            }
          ]);
        } else {
          const items = construirItemsParaNuevoProducto();
          await agregarItemsAlCarrito(items);
        }

        const carrito = await obtenerCarrito();
        renderLineas(carrito);

        trackCarritoPremium('add_to_cart', {
          value: carrito.total_price ? carrito.total_price / 100 : undefined
        });

        modoEdicion = false;
        identificadorEditando = null;
        numeroPersonaEditando = null;

        irAPaso('resumen');
      } catch (error) {
        mostrarMensaje(error.message || 'Ocurrió un error inesperado.');
      } finally {
        setCargando(false);
      }
    });
  }
})();